import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NewsService} from '../../services/news/news.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit {


    news: any;
    endpoint: any;

    constructor(
        private newsService: NewsService,
        private route: ActivatedRoute
    ) {
        const t = this;
        t.endpoint = environment.endpoint;
        if (this.route.snapshot.paramMap.get('id')) {
            this.newsService.find(this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
                t.news = data;
            });
        }
    }


    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }

    ngOnInit(): void {
    }

}
